<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">Dare Me Not: A RH Dark High School Bully Romance (Heartbreak Falls Series, #3)</a></p>
<p><span href="#/c004" title="Link target outside of Sample">Excerpt | CRUEL CRUSH: | Hidden Falls High #1</span></p>
<p><span href="#/c005" title="Link target outside of Sample">Dante Black</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Summer</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Summer</span></p>
<p><span href="#/c008" title="Link target outside of Sample">A Preview from the Upcoming New Release!</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Excerpt | Now Available</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Series Description</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Want to read more? | Diamonds and Dragons is Now Available on KU</span></p>
<p><span href="#/c012" title="Link target outside of Sample">https://dl.bookfunnel.com/tjtn7bbb5y</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?03dbd89e